import NavTab from './NavTab';

function a11yPropsTab(groupId: string = 'nav', index: any) {
  return {
    id: `${groupId}-tab-${index}`,
    'aria-controls': `${groupId}-tabpanel-${index}`,
    role: 'tab',
  };
}

function a11yPropsTabPanel(groupId: string, index: any) {
  return {
    id: `${groupId}-tabpanel-${index}`,
    'aria-labelledby': `${groupId}-tab-${index}`,
    role: 'tabpanel',
  };
}

export { NavTab, a11yPropsTab, a11yPropsTabPanel };
